import {Field, FieldProps} from 'formik';

import SelectOutlet from '../../selectOutlet';

interface TFormikSelectProps extends React.HTMLProps<HTMLSelectElement> {
  name: string;
  label: string;
  Options: Array<IOption>;
  disabled?: boolean;
  isGreen?: boolean;
  hasEmptyData?: boolean;
}
const FormikSelect = ({
  name,
  label,
  disabled,
  Options,
  isGreen,
  hasEmptyData,
  ...props
}: TFormikSelectProps) => {
  return (
    <>
      <Field as="select" name="color">
        {({form}: FieldProps) => {
          return (
            <>
              <SelectOutlet
                hasEmptyData={hasEmptyData}
                isGreen={isGreen}
                required={props.required}
                label={label}
                name={name}
                value={form?.values[name]}
                onBlur={() => form.setFieldTouched(name, true)}
                errors={form?.errors[name]?.toString()}
                touched={
                  Boolean(form?.touched[name]) || form?.values[name]?.length > 0
                }
                options={Options}
                disabled={disabled}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                  form?.setFieldValue(name, e.target.value);
                  props.onChange?.(e);
                }}
              />
            </>
          );
        }}
      </Field>
    </>
  );
};

export default FormikSelect;
